<script setup>
import HotSymbols from '~/components/futures/HotSymbols.vue'
import TickerSymbol from '~/components/futures/TickerSymbol.vue'
import Chart from '~/components/futures/Chart.vue'
import MarketDetail from '~/components/futures/MarketDetail.vue'
// import BonusDriver from '~/components/futures/BonusDriver.vue'
import Panel from '~/components/futures/Panel.vue'
import Order from '~/components/futures/Order.vue'
import FavSymbols from '~/components/futures/FavSymbols.vue'
import { useStore } from '~/store'
import { useFutureStore } from '~/store/future'
import { auth, subscribe } from '~/apis/socket'
import { whenever } from '#imports'
import { useUserStore } from '~/store/user'
import { useStorage } from '@vueuse/core'
import { useTDK } from '~/hooks/seo.js'

definePageMeta({ hideFooter: true })

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const store = useStore()
const future = useFutureStore()
const user = useUserStore()

const title = computed(() => t(`{0} {'|'} {1} 永续 {'|'} TT 合约`, [future.overview?.lp ?? '', future.code]))
const description = computed(() => t('在TT合约平台进行{0}永续合约交易，享受低费用、高流动性与专业级交易工具，为您打造安全、高效的交易体验。立即开始！', [future.code]))

const CalculatorModal = defineAsyncComponent(() => import('@/components/futures/modal/calculator/Calculator.vue'))
// const TransferModal = defineAsyncComponent(() => import('@/components/futures//modal/transfer'))

if (import.meta.client) {
  const unit = useStorage('ttx-unit', 'base')
  future.updateUnit(unref(unit))
}

useTDK({
  title,
  description,
})

watch(() => store.publicData.contracts, (nv) => {
  if (nv.length) {
    const hasCode = nv.some(i => i.code === future.code)
    if (!hasCode) {
      future.code = future.defaultCode
      router.replace({ params: { symbol: future.code } })
    }
  }
})

watch(() => route.params.symbol, () => {
  future.code = route.params.symbol || future.defaultCode
  subscribe({ topic: 'indicator' })
  subscribe({ topic: 'indicator', contractId: future.id })
  subscribe({ topic: 'future_tick', contractId: future.id })
  subscribe({ topic: 'depthChart', contractId: future.id })
}, {
  immediate: true,
})

whenever(() => user.token, auth, { immediate: true })
whenever(() => user.isLogin, () => {
  subscribe({ topic: 'match' })
  store.loadFav()
  future.queryAccountOpend()
}, { immediate: true })
</script>

<template>
  <section class="bg-pageTertiary">
    <FavSymbols />
    <TickerSymbol />
    <div class="flex py-1 space-x-1 rtl:flex-row-reverse">
      <div class="flex-1 space-y-1">
        <div class="flex space-x-1 rtl:flex-row-reverse">
          <Chart />
          <MarketDetail />
        </div>
        <Order />
      </div>
      <Panel />
    </div>
    <CalculatorModal v-model:show="future.modal.calculator" />
    <!-- <TransferModal v-model:show="future.modal.transfer" /> -->
    <FuturesModalOpenContract />
    <FuturesModalOrderConfirm v-model:show="future.modal.orderConfirm" />
  </section>
</template>
